
export const DEALER_CONFIG_TABS_IDS = {
    PRI_LOCATION: "PRI_LOCATION",
    DEPARTMENTS: "DEPARTMENTS"

}
export const DEALER_CONFIG_TABS = [
    {
        displayName: "Primary Location",
        internalName: "PRI_LOCATION",
        selected: true,
    },
    {
        displayName: "Departments",
        internalName: "DEPARTMENTS",
        selected: false,
    }
]

export const DEALERGROUP_CONFIG_TABS = [
    {
        displayName: "Primary Location",
        internalName: "PRI_LOCATION",
        selected: true,
    }
]